import type {
    GetFileDownloadUrlResponse,
    GetFileListRequestQuery,
    GetFileListResponse,
} from '@engagement-web-app/common';
import { APIError } from './types';

export async function fetchUserFiles({ from, limit }: GetFileListRequestQuery): Promise<GetFileListResponse> {
    try {
        const params = new URLSearchParams();
        if (from !== undefined) params.set('from', String(from));
        if (limit !== undefined) params.set('limit', String(limit));
        const res = await fetch(`/api/files?${params.toString()}`);
        const data = await res.json();
        if (!res.ok) throw APIError.fromResponse(data);
        return data;
    } catch (error) {
        if (error instanceof APIError) throw error;
        throw APIError.default();
    }
}

export async function fetchUserFileDownloadUrl(fileId: string): Promise<GetFileDownloadUrlResponse> {
    try {
        const res = await fetch(`/api/files/${fileId}/download-url`);
        const data = await res.json();
        if (!res.ok) throw APIError.fromResponse(data);
        return data;
    } catch (error) {
        if (error instanceof APIError) throw error;
        throw APIError.default();
    }
}
